import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useIsMutating } from 'react-query';
import { usePlateWellActions, useChannels, useTabValue, useAnalysisResults } from '../../../store/plateWellStore';
import { useParams } from 'react-router-dom';
import { Replicates } from '../../constants/analysisType';
import MultiSelect from '../../common/Renderers/MultiSelect';
//import "../../platewells/PlateWell.css"; --> this is pre-loaded in the parent component
import SelectDropDown from '../../common/ReactHookForm/SelectDropDown';
import useMutateReplicateAnalysis from '../../Hooks/Analysis/useMutateReplicateAnalysis';
import Spinner from '../../common/Spinner';
import AnalysisResult from '../../common/TabPanel/AnalysisResult';
import { USER_MESSAGE } from '../../../actions/User';
import { useDispatch } from 'react-redux';
import { parseApiError } from '../../../utils/basic';



const ReplicateAnalysis = () => {

    const { register, handleSubmit, control, reset, formState } = useForm();

    const { plate_uuid } = useParams();
    const { setAnalysisResults, setTabValue } = usePlateWellActions();
    const tabValue = useTabValue();
    const analysisResults = useAnalysisResults();

    const channels = useChannels();
    const optionsForChannels = channels ? channels?.map(item => item.name) : [];
    const replicateAnalysisMutation = useMutateReplicateAnalysis();
    const isMutatingReplicate = useIsMutating({ mutationKey: ['replicateAnalysis'] })
    const dispatch = useDispatch();


    const onSubmit = async (data) => {
        // Map form field names to API field names
        const apiData = {
            metrics: data.Metrics.map(item => item.label),
            replicate_type: data.Replicates,
            channel: data.Channel,
            ignore_wells: data["Ignore Wells"],
            plate_uuid: plate_uuid
        };
        replicateAnalysisMutation.mutate({ apiData },
            {
                onSuccess: (response) => {
                    let responseData = JSON.parse(response?.data);
                    setAnalysisResults(responseData);
                    setTabValue("tab4");
                    reset();
                },
                onError: (error) => {
                    dispatch({
                        type: USER_MESSAGE,
                        msgType: "error",
                        text: parseApiError(error),
                        key: crypto.randomUUID()
                    });
                    reset();
                }
            }
        );
    };

    return (
        isMutatingReplicate ? <Spinner text="Analysing... Will direct you to results tab once complete" /> :
            // analysisResults?.length > 0 ?
            //     <GenericTabs tabsData={analysisResults} tabValue={tabValue} /> :
            analysisResults?.length > 0 && tabValue === "tab4" ? <AnalysisResult /> :
                <div className='pt-10 form-container'>
                    <div className='pb-10 form_area'>
                        <p className='px-2 py-2 title'>Replicate Analysis: Select Metrics</p>
                        <p className='px-2 py-2 text-wrap'>Select the metrics that you want to investigate per technical replicate. Technical replicates have the same sample name and assay targets in the QLP file. </p>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='form-group'>
                                <label className='sub-title'>Metrics</label>
                                <Controller
                                    name="Metrics"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { ref, ...field } }) => <MultiSelect {...field} />}
                                />
                            </div>
                            <div className='form-group'>
                                <label className='sub-title'>Replicates</label>
                                <SelectDropDown className='{`selectDropDown w-full form-style  px-4 py-2 rounded-md  `}'
                                    {...register("Replicates", { required: true })} options={Replicates} name="Replicates" />
                            </div>
                            <div className='form-group'>
                                <label className='sub-title'>Channel</label>
                                <SelectDropDown className='{`selectDropDown w-full form-style  px-4 py-2 rounded-md  `}'
                                    {...register("Channel", { required: true })} options={optionsForChannels} name="Channel" />
                            </div>
                            <div className='form-group'>
                                <label className='sub-title'>Ignore Wells</label>
                                <input placeholder='e.g., D04,E05,B12' className='form-style w-full px-4 py-2  rounded-md' {...register("Ignore Wells")} />
                            </div>

                            <div className='form-group pt-10'>
                                <button className={`ml-10 bg-custom-green text-white px-2 py-1 h-10 rounded-md font-bold 
                        flex items-center justify-center ${formState.isValid ? 'bg-custom-green' : 'bg-gray-400 cursor-not-allowed'}`} type='submit'>Analyze Replicates</button>
                            </div>
                        </form>
                    </div>
                </div>


    );
}
export default ReplicateAnalysis;